import { setParentUrl } from "./parentUrlStore";
import { safeTrackPage } from "./analyticsHelpers";

let initialized = false;

export const initParentUrlListener = () => {
  if (initialized) return;
  initialized = true;

  const handleMessage = (event) => {
    if (event.data?.type === "PARENT_URL") {
      const url = event.data.parentUrl;
      setParentUrl(url);
    }
  };
  window.addEventListener("message", handleMessage);
  const timer = setTimeout(() => {
    safeTrackPage(window.location.href);
  }, 1000);
  return () => {
    window.removeEventListener("message", handleMessage);
    clearTimeout(timer);
  };
};